import { render, staticRenderFns } from "./badmintonCupFull_sudirman.vue?vue&type=template&id=8cced77a"
import script from "./badmintonCupFull_sudirman.vue?vue&type=script&lang=js"
export * from "./badmintonCupFull_sudirman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports